import React from "react";
import { QuestionCard } from "../shared/QuestionCard";
import { QuizChoiceCard, ChoiceOption } from "../form/QuizChoiceCard";
import { Sex } from "@/helpers/enums";
import { quizAsset } from "../shared/quizAssets";

type Props = {
  dogName: string;
  value: string;
  onChange: (sex: string) => void;
};

const OPTIONS: ChoiceOption[] = [
  { value: Sex.MALE, label: "Boy", icon: quizAsset("icon-sex-boy") },
  { value: Sex.FEMALE, label: "Girl", icon: quizAsset("icon-sex-girl") },
];

export function SexQuestion({ dogName, value, onChange }: Props) {
  return (
    <QuestionCard title={`Is ${dogName || "your dog"} a good boy or good girl?`} field="sex">
      <QuizChoiceCard options={OPTIONS} selected={value} onSelect={onChange} />
    </QuestionCard>
  );
}
